module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipeData.recipes.length == 1000),
      expression: "recipeData.recipes.length == 1000"
    }],
    staticClass: "noFavourites"
  }, [_c('p', [_vm._v("You haven't added any recipes to your favourites yet, have a browse!")])]), _vm._v(" "), _vm._l((_vm.recipeData.recipes), function(item, recipeI) {
    return (_vm.recipeData.recipes.length < 1000) ? _c('mu-col', {
      key: 'recipe-' + recipeI,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "33"
      }
    }, [_c('recipe-card', {
      attrs: {
        "recipe": item
      }
    })], 1) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dc311d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Favorites.vue
// module id = 3742
// module chunks = 1